import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "@akuna/ui";
import type { AppointmentWithDetails } from "@/hooks/useAppointments";
import type { AppointmentStatus as ClinicStatus } from "@/hooks/useAppointmentStatuses";
import { buildFlowboardListColumns } from "./flowboardListColumns";

export const FLOWBOARD_LIST_PERSIST_KEY = "flowboard:table";

export interface FlowboardListProps {
  appointments: AppointmentWithDetails[];
  statuses: ClinicStatus[];
  onRowClick: (appointmentId: string) => void;
  /** Controlled column visibility — managed externally so the toggle can live in the page toolbar. */
  visibility: Record<string, boolean>;
}

export function FlowboardList({ appointments, statuses, onRowClick, visibility }: FlowboardListProps) {
  const { t } = useTranslation("calendar");
  const columns = useMemo(() => buildFlowboardListColumns({ t, statuses }), [t, statuses]);

  return (
    <div className="px-3 md:px-10">
      <DataTable
        className="akuna-data-table--no-max-height"
        columns={columns}
        data={appointments}
        defaultSort={{ columnId: "horario", direction: "asc" }}
        empty={t("listEmpty")}
        getRowId={(a) => a.id}
        onRowClick={(a) => onRowClick(a.id)}
        persistKey={FLOWBOARD_LIST_PERSIST_KEY}
        visibility={visibility}
      />
    </div>
  );
}
